import React, { useState } from 'react';
import HeroSection from './components/HeroSection';
import InputSection from './components/InputSection';
import ComplexityControls from './components/ComplexityControls';
import ExplanationOutput from './components/ExplanationOutput';
import FeatureSection from './components/FeatureSection';
import './styles/index.css';

function App() {
  const [topic, setTopic] = useState('');
  const [complexityLevel, setComplexityLevel] = useState(1);
  const [explanation, setExplanation] = useState('');
  const [loading, setLoading] = useState({
    explanation: false,
    feature: false
  });
  const [featureOutput, setFeatureOutput] = useState(null);
  const [activeFeature, setActiveFeature] = useState(null);
  const [apiKey, setApiKey] = useState(localStorage.getItem('sonarApiKey') || '');
  const [activeContent, setActiveContent] = useState('explanation'); 

  const handleClear = () => {
    setTopic('');
    setComplexityLevel(1);
    setExplanation('');
    setFeatureOutput(null);
    setActiveFeature(null);
    setActiveContent('explanation');
  };

  // Update the explanation handler to clear feature content
  const handleExplanationRequest = (explainCallback) => {
    setFeatureOutput(null);
    setActiveFeature(null);
    setActiveContent('explanation');
    explainCallback();
  };

  // Update the feature handler to clear explanation content
  const handleFeatureRequest = (feature) => {
    setExplanation('');
    setActiveContent('feature');
    if (window.handleFeatureClick) {
      window.handleFeatureClick(feature);
    }
  };

  return (
    <div className="container">

      <HeroSection 
          topic={topic}
          setTopic={setTopic}
      />
      
      <InputSection 
        topic={topic}
        setTopic={setTopic}
        onClear={handleClear}
        loading={loading.explanation}
        setLoading={(isLoading) => setLoading({...loading, explanation: isLoading})}
        setExplanation={setExplanation}
        complexityLevel={complexityLevel}
        apiKey={apiKey}
        setApiKey={setApiKey}
        onExplain={handleExplanationRequest}
        onFeatureClick={handleFeatureRequest}
      />

      <ComplexityControls 
        level={complexityLevel}
        setLevel={setComplexityLevel}
      />
      
      <ExplanationOutput 
        explanation={explanation}
        loading={loading.explanation}
        featureOutput={featureOutput}
        featureLoading={loading.feature}
        activeFeature={activeFeature}
        activeContent={activeContent}
      />
      
      {/* Hide the FeatureSection UI but keep its functionality */}
      <div style={{ display: 'none' }}>
        <FeatureSection 
          topic={topic}
          complexityLevel={complexityLevel}
          loading={loading.feature}
          setLoading={(isLoading) => setLoading({...loading, feature: isLoading})}
          featureOutput={featureOutput}
          setFeatureOutput={setFeatureOutput}
          activeFeature={activeFeature}
          setActiveFeature={setActiveFeature}
          apiKey={apiKey}
        />
      </div>
    </div>
  );
}

export default App;